<div class="sidenav2">
    <a class="link" routerLink="/about">About</a>
    <a class="link " routerLink="/gallery">Gallery</a> 
    <a class="link active" routerLink="/shop">Shop</a>
    <div class="dropdown-container">
        <a class="link active">All</a>
        <a class="link">Prints</a>
        <a class="link">Leggings</a>
    </div>
    <a class="link" routerLink="/contact">Contact</a>
  </div>